/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function StarFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="star-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 2.5L14.792 8.157L21.035 9.064L16.518 13.468L17.584 19.686L12 16.75L6.416 19.686L7.482 13.468L2.965 9.064L9.208 8.157L12 2.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M12 2.5L14.792 8.157L21.035 9.064L16.518 13.468L17.584 19.686L12 16.75L6.416 19.686L7.482 13.468L2.965 9.064L9.208 8.157L12 2.5Z" data-tinysvg-shape="star" data-tinysvg-star="12 12 9.5 5 50 0 0" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
